import _, { get, isEmpty, sumBy } from 'lodash';
import { createSelector } from 'reselect';
import { ApplicationState } from '../types';
import {
  buyLabel,
  exchangeLabel,
  sellLabel,
} from './pendingTransactions.module';

export const getPendingTransactions = ({
  pendingTransactions,
}: ApplicationState) => pendingTransactions;

export const getTransactionListByType = createSelector(
  [getPendingTransactions],
  (pendingTransactions) => pendingTransactions?.transactionListByType
);

export const getRecordsByTypeAndAgreement = createSelector(
  [getPendingTransactions],
  (pendingTransactions) => pendingTransactions?.recordsByTypeAndAgreement
);

export const getHasPendingTransactions = createSelector(
  [getTransactionListByType],
  (transactionListByType) => !isEmpty(transactionListByType)
);

export const getBuyPendingTransactions = createSelector(
  [getTransactionListByType],
  (transactionListByType) => transactionListByType?.[buyLabel] || []
);

export const getBuyPendingTransactionRecordsByAgreement = createSelector(
  [getRecordsByTypeAndAgreement],
  (recordsByTypeAndAgreement) => recordsByTypeAndAgreement?.[buyLabel] || {}
);

export const getBuyPendingTransactionsTotal = createSelector(
  getBuyPendingTransactions,
  (buyPendingTransactions) =>
    sumBy(buyPendingTransactions, (pendingTransaction) =>
      pendingTransaction != null
        ? pendingTransaction.transactionRecord.amount
        : 0
    ) || 0
);

export const getExchangePendingTransactions = (state) =>
  get(state, `pendingTransactions.transactionListByType.${exchangeLabel}`, []);
export const getExchangePendingTransactionRecordsByAgreement = (state) =>
  get(
    state,
    `pendingTransactions.recordsByTypeAndAgreement.${exchangeLabel}`,
    {}
  );

export const getSellPendingTransactions = createSelector(
  [getTransactionListByType],
  (transactionListByType) => transactionListByType?.[sellLabel] || []
);

export const getSellPendingTransactionRecordsByAgreement = createSelector(
  [getRecordsByTypeAndAgreement],
  (recordsByTypeAndAgreement) => recordsByTypeAndAgreement?.[sellLabel] || {}
);

export const getPendingBuyExchangeSellTransactionRecordsByAgreement =
  createSelector(
    getBuyPendingTransactionRecordsByAgreement,
    getExchangePendingTransactionRecordsByAgreement,
    getSellPendingTransactionRecordsByAgreement,
    (
      buyPendingTransactionRecordsByAgreement,
      exchangePendingTransactionRecordsByAgreement,
      sellPendingTransactionRecordsByAgreement
    ) => {
      return [
        buyPendingTransactionRecordsByAgreement,
        exchangePendingTransactionRecordsByAgreement,
        sellPendingTransactionRecordsByAgreement,
      ];
    }
  );

export const getJustPendingAgreementIDs = createSelector(
  getPendingBuyExchangeSellTransactionRecordsByAgreement,
  (pendingByAgreement) => {
    pendingByAgreement = pendingByAgreement.filter(
      (fund) => Object.keys(fund).length !== 0
    );
    pendingByAgreement = pendingByAgreement.map((fund) => Object.keys(fund));
    pendingByAgreement = _.flatten(pendingByAgreement);
    return pendingByAgreement;
  }
);

export const getPendingBuyExchangeSellTransactionRecordsByAgreementGrouped =
  createSelector(
    getBuyPendingTransactionRecordsByAgreement,
    getExchangePendingTransactionRecordsByAgreement,
    getSellPendingTransactionRecordsByAgreement,
    (
      buyPendingTransactionRecordsByAgreement,
      exchangePendingTransactionRecordsByAgreement,
      sellPendingTransactionRecordsByAgreement
    ) => {
      return {
        [buyLabel]: buyPendingTransactionRecordsByAgreement,
        [exchangeLabel]: exchangePendingTransactionRecordsByAgreement,
        [sellLabel]: sellPendingTransactionRecordsByAgreement,
      };
    }
  );
